import o from "styled-components";
const p = ({
  $colorTheme: r = "light",
  isError: t,
  isGroupedInput: n,
  theme: i
}) => t ? i == null ? void 0 : i.get(`tokens.text.${r}.error`) : n ? i == null ? void 0 : i.get(`tokens.text.${r}.tertiary`) : i == null ? void 0 : i.get(`tokens.text.${r}.primary`), g = o.div`
  ${({ theme: r }) => {
  var t;
  return (t = r == null ? void 0 : r.get("tokens.helper.productive")) == null ? void 0 : t.toJS();
}}

  color: ${({ $colorTheme: r = "light", $isError: t, $isGroupedInput: n, theme: i }) => p({ $colorTheme: r, isError: t, isGroupedInput: n, theme: i })};
  padding-bottom: ${({ $isGroupedInput: r }) => r ? 8 : 0}px;
  padding-left: ${({ $isGroupedInput: r }) => r ? "var(--padding-x)" : 0};
  padding-right: ${({ $isGroupedInput: r }) => r ? "var(--padding-x)" : 0};
`;
export {
  g as InputHelper
};
